/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Draf_S1Inputs */

const en_tut_draf_s1 = /** @type {(inputs: Tut_Draf_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End the meeting first; a draft can only be made from the transcript of a finished meeting.`)
};

const id_tut_draf_s1 = /** @type {(inputs: Tut_Draf_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akhiri rapat terlebih dahulu; draf hanya bisa dibuat dari transkrip rapat yang sudah selesai.`)
};

/**
* | output |
* | --- |
* | "End the meeting first; a draft can only be made from the transcript of a finished meeting." |
*
* @param {Tut_Draf_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_draf_s1 = /** @type {((inputs?: Tut_Draf_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Draf_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_draf_s1(inputs)
	return en_tut_draf_s1(inputs)
});